// A empty file for jest v8 coverage provider
